import { Users } from "lucide-react";
import { useTaal } from "@/contexts/TaalContext";

/**
 * Glasronde 0.9.234 (Frank 2 november 2026) punt 1 en 2: bij welk team een repo hoort en welke rol jij daar hebt,
 * op een plek: in de lijst van Repo's, bovenaan een repo en bovenaan Code naast de naam. Toont niets bij een
 * persoonlijke repo (`teamNaam` leeg).
 */
export const ROL_NAAM = { viewer: "kijker (viewer)", member: "lid (member)", admin: "beheerder (admin)" };

export default function TeamRolLabel({ teamNaam, rol, testid = "team-rol" }) {
  const { t } = useTaal();
  if (!teamNaam) return null;
  return (
    <span className="inline-flex min-w-0 items-center gap-1 rounded-full border px-2 text-xs font-normal text-muted-foreground"
          data-testid={testid}>
      <Users className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span className="truncate">
        {t("Team {team}, jouw rol: {rol}", { team: teamNaam, rol: t(ROL_NAAM[rol] || rol || "") })}
      </span>
    </span>
  );
}
